import * as React from 'react';
import { FormControl } from '@material-ui/core';
import IntegrationReactSelect from '@/app/components/IntegrationReactSelect/IntegrationReactSelect';
import { styles } from '@/app/components/FormFields/formFieldsStyle';

const RenderSelectField = (props: any) => {
  const {
    input,
    label,
    required,
    meta: { touched, dirty, error },
    children,
    helpText,
    ...custom
  } = props;

  const hasError = (touched || dirty) && !!error;

  return (
    <FormControl
      style={styles.textField}
      fullWidth
      margin="normal"
    >
      <IntegrationReactSelect
        {...input}
        error={hasError ? error : null}
        onChange={input.onChange}
        onBlur={(event: any) => event.preventDefault()}
        children={children}
        required={required}
        fullWidth
        {...custom}
      />
      {helpText}
    </FormControl>
  );
};

export default RenderSelectField;
